import React, { useEffect, useState } from "react";
import { Card, Table, Select, Row, Col, message, Button, Spin } from "antd";
import { DownloadOutlined } from "@ant-design/icons"; 
import { useNavigate } from "react-router-dom";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import ReportService from "Services/AdminServices/ReportServices";
import jsPDF from "jspdf";
import "jspdf-autotable";
import { JobPostingStatusEnum , getStatusKey } from "Constants/Enums/JobPostingStatusEnum";
import moment from "moment";

const { Option } = Select;

const SpecRecruitment = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [departments, setDepartments] = useState([]);
  const [selectedDepartment, setSelectedDepartment] = useState(null);
  const [jobPostings, setJobPostings] = useState([]);

  //  Fetch departments
  const fetchDepartments = async () => {
    try {
      const response = await ReportService.getDepartments();
      if (response.data && Array.isArray(response.data)) {
        setDepartments(response.data);
      } else {
        message.warning("No departments found");
      }
    } catch (error) {
      message.error("Failed to load departments");
    }
  };

  //  Fetch hiring report
  const fetchHiringReport = async (departmentId = null) => {
    setLoading(true);
    try {
      const response = await ReportService.getHiringReport(departmentId);
      if (response.data && Array.isArray(response.data)) {
        setJobPostings(response.data);
      } else {
        setJobPostings([]);
        message.warning("No hiring data found");
      }
    } catch (error) {
    
    } finally {
      setLoading(false);
    }
  };

 useEffect(() => {
  const loadDepartments = async () => {
    try {
      const response = await ReportService.getDepartments();
      const deptList = response.data || [];
      setDepartments(deptList);

      // Default to All Departments
      setSelectedDepartment("all");  // string "all"
      fetchHiringReport(null);        // fetch all
    } catch (error) {
      message.error("Failed to load departments");
    }
  };

  loadDepartments();
}, []);

  //  Handle department change
  const handleDepartmentChange = (value) => {
    setSelectedDepartment(value);
    fetchHiringReport(value);
  };

  //  PDF Download
  const handleDownloadPdf = () => {
    if (!jobPostings.length) {
      message.warning("No data to export");
      return;
    }

    const doc = new jsPDF("landscape");
    doc.setFontSize(16);
    doc.text("Hiring Report", 14, 15);

    const currentDate = new Date().toLocaleDateString();
    doc.setFontSize(10);
    doc.text(`Generated on: ${currentDate}`, 14, 22);

    const tableData = jobPostings.map((job) => [
      job.jobTitle || "N/A",
      job.departmentName || "N/A",
      job.jobType || "N/A",
      job.jobLocationType || "N/A",
      job.applicantsCount || 0,
      getStatusKey(job.status) || "Unknown",
      job.createdOn ? moment(job.createdOn).format("MMM DD, YYYY") : "N/A"
    ]);

    doc.autoTable({
  startY: 30,
  head: [["Job Title", "Department", "Type", "Location", "Applicants", "Status", "Created On"]],
  body: tableData,
  styles: {
    fontSize: 8,
    halign: 'center', // centers all table cells
    valign: 'middle', // vertically centers text in cells
  },
  headStyles: {
    fillColor: [0, 123, 255],
    textColor: 255,
    halign: 'center', // centers header text
    valign: 'middle',
  },
});

    const deptName =
      departments.find((d) => d.id === selectedDepartment)?.name || "All_Departments";
    doc.save(`Hiring_Report_${deptName}.pdf`);
  };

  

  //  Table Columns
  const columns = [
    {
      title: "Job Title",
      dataIndex: "jobTitle",
      key: "jobTitle",
    },
    {
      title: "Department",
      dataIndex: "departmentName",
      key: "departmentName",
    },
    {
      title: "Job Type",
      dataIndex: "jobType",
      key: "jobType",
    },
    {
      title: "Location Type",
      dataIndex: "jobLocationType",
      key: "jobLocationType",
    },
    {
      title: "Applicants",
      dataIndex: "applicantsCount",
      key: "applicantsCount",
      align: "center",
    },
    {
  title: "Status",
  dataIndex: "status",
  key: "status",
  render: (status) => getStatusKey(status) || "Unknown",
},
    {
      title: "Created On",
      dataIndex: "createdOn",
      key: "createdOn",
      render: (date) => date ? moment(date).format("MMM DD, YYYY") : "N/A"
    },
  ];

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <div style={{ padding: "24px" }}>
        <Card
          title="Hiring  Report"
          extra={
            <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
              <Button onClick={() => navigate(-1)}>Back</Button>
              <Button className="btn-primary" icon={<DownloadOutlined />} onClick={handleDownloadPdf}>
                Download PDF
              </Button>
          
            </div>
          }
        >
          <Row gutter={[16, 16]} style={{ marginBottom: 16 }}>
            <Col xs={24} sm={12} md={6}>
            <Select
  allowClear
  placeholder="Select Department"
  style={{ width: "100%" }}
  value={selectedDepartment || "all"}
  onChange={(value) => {
    setSelectedDepartment(value);
    fetchHiringReport(value === "all" ? null : value); // send null for all departments
  }}
>
  <Option value="all">All Departments</Option>
  {departments.map((dept) => (
    <Option key={dept.id} value={dept.id}>
      {dept.name}
    </Option>
  ))}
</Select>
            </Col>
          </Row>

          {loading ? (
            <div style={{ textAlign: "center", padding: "50px" }}>
              <Spin size="large" />
            </div>
          ) : (
            <Table
              columns={columns}
              dataSource={jobPostings}
              rowKey={(record) => record.id}
              pagination={{ pageSize: 10 }}
            />
          )}
        </Card>
      </div>
    </DashboardLayout>
  );
};

export default SpecRecruitment;
